var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaReplayOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22c-1.25 0-2.42-.237-3.512-.712a9.142 9.142 0 01-2.85-1.926 9.143 9.143 0 01-1.926-2.85A8.709 8.709 0 013 13h2c0 1.95.68 3.604 2.038 4.962C8.396 19.321 10.05 20 12 20c1.95 0 3.604-.68 4.962-2.038C18.321 16.604 19 14.95 19 13c0-1.95-.68-3.604-2.038-4.963C15.604 6.679 13.95 6 12 6h-.15l1.55 1.55L12 9 8 5l4-4 1.4 1.45L11.85 4H12c1.25 0 2.421.238 3.513.713a9.154 9.154 0 012.85 1.924 9.167 9.167 0 011.925 2.85A8.715 8.715 0 0121 13c0 1.25-.237 2.42-.712 3.512a9.151 9.151 0 01-1.925 2.85 9.158 9.158 0 01-2.85 1.926A8.715 8.715 0 0112 22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaReplayOutline);
export default __webpack_public_path__ + "0323c0523bf0e30f0e0fffc5ed4fc1e8.svg";
export { ForwardRef as ReactComponent };